import React from 'react';
import { Box, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export type ListPageActiveFilterChip = {
  /** Stable id for React key (e.g. field name or `tag:oro`). */
  key: string;
  /** Display label, e.g. `Búsqueda: anillo`. */
  label: string;
  onRemove: () => void;
};

export type ListPageActiveFiltersProps = {
  chips: ListPageActiveFilterChip[];
  /** Prefix label before chips. */
  title?: string;
};

const ActiveFiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

const ActiveFiltersTitle = styled(Box)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  marginRight: theme.spacing(0.5),
}));

const ActiveFiltersChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  maxWidth: 280,
  '& .MuiChip-label': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

/**
 * Removable chips for filters already applied to the list (post-Buscar).
 * Location scope toolbar control is separate — do not pass it as a chip.
 */
const ListPageActiveFilters: React.FC<ListPageActiveFiltersProps> = ({
  chips,
  title = 'Filtros activos:',
}) => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <ActiveFiltersContainer>
      <ActiveFiltersTitle>{title}</ActiveFiltersTitle>
      {chips.map((chip) => (
        <ActiveFiltersChip
          key={chip.key}
          label={chip.label}
          onDelete={chip.onRemove}
          size="small"
        />
      ))}
    </ActiveFiltersContainer>
  );
};

export default ListPageActiveFilters;
